import {Injectable} from "@angular/core";
import {LanguageSelectorComponent} from "@app/presentation/pages/language-selector/language-selector.component";
import {SideSheetService} from "@app/presentation/services/side-sheet/side-sheet.service";
import {
    ConditionalSideSheetService
} from "@app/presentation/services/conditional-side-sheet/conditional-side-sheet.service";

@Injectable()
export class LanguageSelectorService {

    constructor(
        private sideSheetService: SideSheetService,
        private conditionalSideSheetService: ConditionalSideSheetService,
    ) {}
    openLanguageSelector() {
        this.conditionalSideSheetService.open(['/','language-selector'], LanguageSelectorComponent);
    }
}
